// placeholder for police CAD / PSAP / rules-engine checks
// return true if external system confirms same incident
export async function verifyDuplicateWithCAD(candidate, parent) {
  // TODO: wire real API here. For now, simulate “unknown” (no confirmation).
  return false;
}

